import { featuredDramas } from '@/mocks/dramas';
import DramaCard from '@/components/base/DramaCard';

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-fire-line text-accent-500 text-lg"></i>
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950">热门推荐</h2>
            </div>
            <p className="text-sm text-foreground-500">精选高分好剧，每一部都不容错过</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {featuredDramas.map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </div>
    </section>
  );
}